import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

interface CreatePaymentIntentRequest {
  paymentMethodId?: string;
  userId?: string;
  discountCode?: string;
  productId?: string;
  name?: string;
  email?: string;
}

interface CreatePaymentIntentResponse {
  clientSecret?: string;
  customerId?: string;
  paymentMethodId?: string;
  subscriptionId?: string;
  status?: string;
}

export const useMakeSubscriptionPayment = (
  options?: UseMutationOptions<
    CreatePaymentIntentResponse,
    unknown,
    CreatePaymentIntentRequest,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: CreatePaymentIntentRequest) =>
      axiosInstance
        .post(getAPIURL("/SubscriptionPayment/create-subscription"), data)
        .then((res) => res.data),
  });
};
